<template>
    <div
        class="px-6 py-5 flex items-center space-x-3 bg-white border border-1  hover:bg-gray-100 cursor-pointer focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 rounded-md transition-all duration-300">
        <div class="flex-shrink-0">
            <img :alt="name"
                 class="h-8 w-8 rounded-full p-3 bg-gray-300 "
                 src="@src/assets/vectors/user_icon.svg"
            >
        </div>
        <div class="flex-1 min-w-0">
            <div class="focus:outline-none">
                <p class="text-sm font-medium text-gray-900">
                    {{ name }}
                </p>
                <p class="text-sm text-gray-500 truncate">
                    {{ phoneNumber }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import * as vCard from 'vcard-parser';

const props = defineProps(['contact'])
let name = ref<string>('')
let phoneNumber = ref<string>('')

onMounted(() => {
    const card = vCard.parse(props.contact)
    name.value = card.fn[0].value;
    phoneNumber.value = card.tel[0].value;
})
</script>

<style scoped>

</style>
